import React, { useEffect, useState } from "react";
import { Plane, CalendarClock, Users, Send, Wrench } from "lucide-react";
import { api } from "../../../../lib/api";
import { D, Chip } from "../../ui";
import { BandaraJadwal } from "./BandaraJadwal";
import { BandaraPendatang } from "./BandaraPendatang";
import { BandaraKirim } from "./BandaraKirim";
import { BandaraAksi } from "./BandaraAksi";

const TABS = [["jadwal", "Jadwal", CalendarClock], ["pendatang", "Pendatang", Users], ["kirim", "Kirim balasan", Send], ["aksi", "Aksi", Wrench]];
export const WIB = iso => new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta" }).replace(":", ".");
export const hitungMundur = ms => { const s = Math.max(0, Math.ceil(ms / 1000)); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`; };

// Kartu "Bandara Jawsel" di Dashboard (menggantikan grafik): jadwal penerbangan pendatang realtime, antrean, status kirim balasan IG. Polling 5 dtk.
export function BandaraCard({ token, card, cardTitle }) {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("jadwal");
  const [tick, setTick] = useState(0);
  const [offset, setOffset] = useState(0);   // jam server − jam browser
  const muat = () => api.adminBandara(token).then(r => { setD(r); setOffset(Date.parse(r.now) - Date.now()); }).catch(() => {});
  useEffect(() => { muat(); const t = setInterval(muat, 5000); const k = setInterval(() => setTick(x => x + 1), 1000); return () => { clearInterval(t); clearInterval(k); }; }, [token]); // eslint-disable-line

  const now = Date.now() + offset;
  const aktif = d?.penerbangan.find(f => { const t = now - Date.parse(f.berangkat_at); return t >= 0 && t < 42000; });
  const depan = d?.penerbangan.filter(f => Date.parse(f.berangkat_at) > now).sort((a, b) => Date.parse(a.berangkat_at) - Date.parse(b.berangkat_at))[0];
  const hero = aktif || depan;
  const S = d?.statistik || {};

  return (
    <div data-testid="bandara-card" style={{ ...card, flex: 1.5, minWidth: 420, display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ width: 34, height: 34, borderRadius: 11, background: D.blueSoft, display: "grid", placeItems: "center" }}><Plane size={16} color={D.blue} /></span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <b style={cardTitle}>Bandara Jawsel</b>
          <span style={{ display: "block", fontSize: 11, color: D.sub, fontWeight: 600 }}>pendatang dari komentar IG “{d?.kata_pemicu || "terjun"}” · jam server WIB · diperbarui tiap 5 dtk</span>
        </div>
        {d && <Chip tone={d.tersambung ? "green" : "amber"} testid="bandara-ig-chip">{d.tersambung ? "IG tersambung" : "IG mode simulasi"}</Chip>}
      </div>

      {/* Hero: penerbangan aktif / berikutnya */}
      <div data-testid="bandara-hero" style={{ borderRadius: 20, padding: "16px 18px", background: hero ? D.dark : D.cream, color: hero ? "#fff" : D.sub, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        {hero ? (
          <>
            <div style={{ flex: 1, minWidth: 160 }}>
              <span style={{ fontSize: 10.5, letterSpacing: 1.5, fontWeight: 800, textTransform: "uppercase", opacity: .7 }}>{aktif ? "Sedang terjun" : "Penerbangan berikutnya"}</span>
              <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: -0.8, marginTop: 4 }} data-testid="bandara-hero-nomor">{hero.nomor} <span style={{ fontSize: 16, fontWeight: 700, opacity: .85 }}>· {hero.berangkat_wib} WIB</span></div>
              <span style={{ fontSize: 12, opacity: .75 }}>{hero.penumpang.length}/{hero.muat} kursi · {hero.penumpang.slice(0, 4).map(p => `@${p.username}`).join(", ")}{hero.penumpang.length > 4 ? ` +${hero.penumpang.length - 4}` : ""}</span>
            </div>
            <div style={{ textAlign: "right" }}>
              <div data-testid="bandara-hero-countdown" style={{ fontSize: 34, fontWeight: 800, fontVariantNumeric: "tabular-nums", letterSpacing: -1, color: aktif ? "#4ade80" : "#9f9fff" }}>{aktif ? "LIVE" : hitungMundur(Date.parse(hero.berangkat_at) - now)}</div>
              <span style={{ fontSize: 10.5, opacity: .7 }}>{aktif ? "pesawat melintas di beranda" : "menit:detik"}</span>
            </div>
          </>
        ) : <span data-testid="bandara-hero-kosong" style={{ fontSize: 13, fontWeight: 600 }}>{d ? "Tidak ada penerbangan terjadwal — pesawat hanya terbang bila ada pendatang." : "Memuat bandara…"}</span>}
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {[["Antre kursi", S.antre], ["Pendatang hari ini", S.pendatang_hari_ini], ["Penerbangan hari ini", S.penerbangan_hari_ini], ["Sudah terjun", S.diterbangkan_total]].map(([l, v]) => (
          <div key={l} style={{ flex: 1, minWidth: 100, padding: "8px 12px", borderRadius: 14, background: D.cream }}>
            <span style={{ display: "block", fontSize: 10, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: D.sub }}>{l}</span>
            <b style={{ fontSize: 18, color: D.ink }}>{v ?? "–"}</b>
          </div>
        ))}
      </div>

      <div style={{ display: "inline-flex", gap: 4, background: D.cream, borderRadius: 99, padding: 4, alignSelf: "flex-start" }}>
        {TABS.map(([k, l, Icon]) => (
          <button key={k} data-testid={`bandara-tab-${k}`} onClick={() => setTab(k)}
            style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 13px", borderRadius: 99, border: 0, cursor: "pointer", fontSize: 12, fontWeight: 700, fontFamily: "inherit", background: tab === k ? D.dark : "transparent", color: tab === k ? "#fff" : D.ink, transition: "background-color .15s" }}>
            <Icon size={13} color={tab === k ? "#9f9fff" : D.blue} /> {l}
            {k === "kirim" && (d?.ringkas_kirim?.gagal || d?.ringkas_kirim?.kedaluwarsa) ? <span data-testid="bandara-kirim-badge" style={{ minWidth: 16, height: 16, padding: "0 4px", borderRadius: 99, background: D.danger, color: "#fff", fontSize: 10, display: "grid", placeItems: "center" }}>{(d.ringkas_kirim.gagal || 0) + (d.ringkas_kirim.kedaluwarsa || 0)}</span> : null}
          </button>
        ))}
      </div>

      {d && (tab === "jadwal" ? <BandaraJadwal d={d} now={now} />
        : tab === "pendatang" ? <BandaraPendatang token={token} d={d} onChanged={muat} />
        : tab === "kirim" ? <BandaraKirim token={token} d={d} onChanged={muat} />
        : <BandaraAksi token={token} d={d} onChanged={muat} />)}
      {!d && tick > 3 && <p style={{ margin: 0, fontSize: 12.5, color: D.sub }}>Bandara belum bisa dimuat.</p>}
    </div>
  );
}
